import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Cookies from 'js-cookie';
import translationEN from './locales/en/translation.json';
import translationID from './locales/id/translation.json';

const resources = {
	en: {
		translation: translationEN,
	},
	id: {
		translation: translationID,
	},
};

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		fallbackLng: 'id',
		detection: {
			order: ['cookie', 'navigator'],
			caches: ['cookie'],
		},
		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;
